import React, { useState } from "react";

export default function PreferenciasPage() {
  // ---- ESTADOS DE SECCIÓN IDENTIDAD VISUAL ----
  const [logo, setLogo] = useState("");        // Para mostrar preview local
  const [logoFile, setLogoFile] = useState();  // Archivo real para enviar al back
  const [encabezadoFactura, setEncabezadoFactura] = useState("");
  const [pieFactura, setPieFactura] = useState("");
  const [otrasResponsabilidades, setOtrasResponsabilidades] = useState("");
  const [recibirCopiaPlataforma, setRecibirCopiaPlataforma] = useState(false);
  const [erpOrigen, setErpOrigen] = useState("");
  const [otroErp, setOtroErp] = useState("");
  const [loading, setLoading] = useState(false);

  // Handler para logo: guarda preview Y archivo real
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogo(URL.createObjectURL(file));
      setLogoFile(file); // Aquí guardamos el archivo real
    }
  };

  // Envío al backend con FormData (asíncrono)
  const handleGuardar = async (e) => {
    e.preventDefault();
    if (!erpOrigen) {
      alert("Por favor selecciona el ERP de origen.");
      return;
    }
    if (erpOrigen === "Otro" && !otroErp.trim()) {
      alert("Por favor indica el nombre del ERP si seleccionaste 'Otro'.");
      return;
    }
    setLoading(true);

    try {
      const formData = new FormData();
      if (logoFile) formData.append("logo", logoFile);
      formData.append("encabezadoFactura", encabezadoFactura);
      formData.append("pieFactura", pieFactura);
      formData.append("otrasResponsabilidades", otrasResponsabilidades);
      formData.append("recibirCopiaPlataforma", recibirCopiaPlataforma);
      formData.append("erpOrigen", erpOrigen === "Otro" ? otroErp : erpOrigen);

      // TODO: Cambia la URL por tu endpoint real
      const response = await fetch("/api/preferencias", {
        method: "POST",
        body: formData,
        // No incluyas Content-Type cuando uses FormData, el browser lo pone solo
      });

      if (!response.ok) throw new Error("Error al guardar preferencias");

      alert("¡Preferencias guardadas con éxito!");
      // Opcional: limpiar logoFile si quieres resetear el form
      // setLogoFile(undefined);

    } catch (err) {
      alert("Hubo un error guardando las preferencias: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white w-full max-w-2xl mx-auto rounded-2xl shadow-xl px-8 py-8 border">
      <h3 className="text-2xl font-bold text-[#003865] mb-6">
        Mis Preferencias
      </h3>
      <form className="space-y-8" onSubmit={handleGuardar}>
        <section>
          <h4 className="text-lg font-semibold text-[#003865] mb-3 border-b pb-2">
            Identidad Visual
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Logo */}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1 text-gray-800">
                Logo de la empresa
              </label>
              <div className="flex items-center gap-4">
                {logo ? (
                  <img src={logo} alt="Logo" className="w-16 h-16 rounded-full border object-contain" />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-gray-100 border flex items-center justify-center text-gray-400">
                    Sin logo
                  </div>
                )}
                <input type="file" accept="image/*" onChange={handleLogoChange} className="text-sm" />
              </div>
            </div>
            {/* Encabezado de factura */}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1 text-gray-800">
                Encabezado de factura
              </label>
              <input
                type="text"
                value={encabezadoFactura}
                onChange={e => setEncabezadoFactura(e.target.value)}
                className="border border-gray-200 rounded-lg h-10 p-2 w-full"
                placeholder="Ejemplo: Tiendas Fedelza S.A.S - NIT 900.999.999-1"
              />
            </div>
            {/* Pie de factura */}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1 text-gray-800">
                Pie de factura
              </label>
              <textarea
                value={pieFactura}
                onChange={e => setPieFactura(e.target.value)}
                className="border border-gray-200 rounded-lg p-2 w-full min-h-[42px]"
                placeholder="Ejemplo: Resolución DIAN 123456 de 2024. Pagos a 30 días."
              />
            </div>
            {/* Otras responsabilidades fiscales */}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1 text-gray-800">
                Otras responsabilidades fiscales
              </label>
              <textarea
                value={otrasResponsabilidades}
                onChange={e => setOtrasResponsabilidades(e.target.value)}
                className="border border-gray-200 rounded-lg p-2 w-full min-h-[38px]"
                placeholder="Ejemplo: Régimen común, Autorretenedor, etc."
              />
            </div>
            {/* Copia en plataforma de gestión documental */}
            <div className="md:col-span-2 flex items-center mt-2">
              <input
                id="recibirCopiaPlataforma"
                type="checkbox"
                checked={recibirCopiaPlataforma}
                onChange={e => setRecibirCopiaPlataforma(e.target.checked)}
                className="rounded border-gray-300 text-[#003865] focus:ring-[#003865] mr-2"
              />
              <label htmlFor="recibirCopiaPlataforma" className="text-sm text-gray-800 cursor-pointer">
                ¿Desea recibir copia de los documentos en su plataforma de gestión documental?
              </label>
            </div>
            <div className="md:col-span-2 text-xs text-gray-500 pl-6 -mt-2 mb-3">
              *Nota: esta funcionalidad será integrada con la plataforma de gestión documental del cliente. Sujeto a negociación comercial.
            </div>
            {/* ERP de origen */}
            <div className="md:col-span-2">
              <label className="block font-semibold mb-1 text-gray-800">
                ¿Desde qué ERP nos envía sus facturas electrónicas? <span className="text-red-500">*</span>
              </label>
              <select
                value={erpOrigen}
                onChange={e => setErpOrigen(e.target.value)}
                className="border border-gray-200 rounded-lg h-10 p-2 w-full"
                required
              >
                <option value="">Seleccione...</option>
                <option value="Siesa Enterprise">Siesa Enterprise</option>
                <option value="Siesa SBS">Siesa SBS</option>
                <option value="Siesa 8.5">Siesa 8.5</option>
                <option value="Otro">Otro</option>
              </select>
              {erpOrigen === "Otro" && (
                <input
                  type="text"
                  value={otroErp}
                  onChange={e => setOtroErp(e.target.value)}
                  className="border border-gray-200 rounded-lg h-10 p-2 w-full mt-2"
                  placeholder="Indique el nombre de su ERP"
                  required
                />
              )}
            </div>
          </div>
        </section>

        {/* --- MÁS SECCIONES AQUÍ --- */}

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="bg-[#003865] text-white px-8 py-3 rounded-xl shadow font-bold text-base hover:bg-blue-700 transition"
            disabled={loading}
          >
            {loading ? "Guardando..." : "Guardar preferencias"}
          </button>
        </div>
      </form>
    </div>
  );
}
